
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule } from '@/store'

import AddressDto from '@/types/dto/addressDto'
import LookupValueDto from '@/types/dto/lookupValueDto'

import AddressLookup from '@/components/shared/AddressLookup.vue'

	@Component({
	  name: 'AddressDetails',
	  components: {
	    AddressLookup
	  }
	})
export default class AddressDetails extends Vue implements IAppForm {
		// #region Props
		@Prop() address!: AddressDto;
		@Prop() addressIndex!: number;
		@Prop({ default: false }) editing!: boolean;
		@Prop({ default: false }) isNew!: boolean;

		// #endregion

		// #region Data

		value = ApplicationModule.form;
		manual = false;

		show = true;
		showAddressError = false;
		showError = false;

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit')
		}

		previous () {
		  this.$emit('previous')
		}

		validate () {
		  return (this.$refs.addressLookup as unknown as IAppForm).validate()
		}

		setManual () {
		  this.manual = true
		}

		setAddress (val: AddressDto) {
		  this.showAddressError = false

		  val.residentialStatusLookup = { id: -1 } as LookupValueDto
		  val.yearsAtAddress = 0
		  val.monthsAtAddress = 0

		  ApplicationModule.updateAddress(val)
		  this.address = val

		  this.$emit('address-selected', val)
		}

		// #endregion

		// #region Computed

		get editingAddressIndex () {
		  return ApplicationModule.editingAddressIndex
		}

		get isManual () {
		  return this.address.postcode && this.address.postcode !== ''
		}
		// #endregion

		// #region Watches

		@Watch('editingAddressIndex')
		changeEmployment () {
		  this.showAddressError = false
		  this.manual = false
		  this.show = false
		  setTimeout(() => {
		    this.show = true
		  }, 0)
		}

  // #endregion
}
